import React from 'react'

const Chatslist = () => {
  return (
    <div>Chatslist</div>
  )
}

export default Chatslist